import type {PaymentMethod} from "../../../../domain/entities/PaymentMethod";
import styles from "../../../pages/checkout/CheckoutPage.module.css";

interface PaymentMethodOptionProps {
    method: PaymentMethod;
    isSelected: boolean;
    onSelect: (paymentMethodId: string) => void;
}

export const PaymentMethodOption = ({method, isSelected, onSelect}: PaymentMethodOptionProps) => (
    <label
        htmlFor={method.code}
        className={`${styles.paymentMethodCard} ${isSelected ? styles.paymentMethodCardSelected : ""}`}
    >
        <input
            id={method.code}
            name="payment-method"
            type="radio"
            className={styles.paymentMethodInput}
            checked={isSelected}
            onChange={() => onSelect(method.code)}
            value={method.code}
        />
        <div className={styles.paymentMethodContent}>
            <span className={styles.paymentMethodTitle}>{method.name}</span>
            {method.description && <p className={styles.paymentMethodDescription}>{method.description}</p>}
        </div>
    </label>
);
